import actions from "@/store/modules/supplier/actions";
import mutations from "@/store/modules/supplier/mutations";
import state from "@/store/modules/supplier/state";

export default {
    actions,
    mutations,
    state
}